import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, Routes, Route, Link } from "react-router-dom";
import "./App.css";
import { TaskSelectionPage } from "./components/pages/task-selection";
import { OnboardingPage } from "./components/pages/onboarding";
import { RecordingPage } from "./components/pages/recording";
import { WelcomeScreen } from "./components/auth/WelcomeScreen";
import { AuthOnboarding } from "./components/auth/AuthOnboarding";
import { SplashScreen } from "./components/auth/SplashScreen";
import { ProtectedRoute } from "./components/auth/ProtectedRoute";
import { AuthProvider } from "./auth/AuthContext";
import { TaskProvider } from "./providers/task-provider";
import { SubmissionProvider } from "./providers/submission-provider";
import { ConditionalNavbar } from "./components/molecules/conditional-navbar";
import { HistoryPage } from "./components/pages/history";
import { AuthScreen } from "./components/auth/AuthScreen";
import { PaymentOnboard } from "./components/pages/payment-onboard";
import { PaymentHistory } from "./components/pages/payment-history";
import { PayoutProvider } from "./providers/payout-provider";
import { Instructions } from "./components/pages/instructions";
import { QueryParamsProvider } from "./providers/query-params-provider";

function App() {
  const [showSplash, setShowSplash] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowSplash(false);
    }, 1500);
    return () => clearTimeout(timer);
  }, []);

  if (showSplash) {
    return <SplashScreen />;
  }

  return (
    <AuthProvider>
      <TaskProvider>
        <SubmissionProvider>
          <PayoutProvider>
            <Router>
              <QueryParamsProvider>
                <div className="App">
                  <ConditionalNavbar />
                  <Routes>
                    <Route path="/welcome" element={<WelcomeScreen />} />
                    <Route
                      path="/auth-onboarding"
                      element={<AuthOnboarding />}
                    />
                    <Route path="/signup" element={<AuthScreen />} />
                    <Route
                      path="/signup-internal"
                      element={<AuthScreen isInternal={true} />}
                    />
                    <Route path="/login" element={<AuthScreen />} />
                    <Route
                      path="/payment-onboard"
                      element={
                        <ProtectedRoute>
                          <PaymentOnboard skippIfDataExists={true} />
                        </ProtectedRoute>
                      }
                    />
                    <Route
                      path="/instructions"
                      element={
                        <ProtectedRoute>
                          <Instructions />
                        </ProtectedRoute>
                      }
                    />
                    <Route
                      path="/payment-edit"
                      element={
                        <ProtectedRoute>
                          <PaymentOnboard skippIfDataExists={false} />
                        </ProtectedRoute>
                      }
                    />
                    <Route
                      path="/"
                      element={
                        <ProtectedRoute>
                          <TaskSelectionPage />
                        </ProtectedRoute>
                      }
                    />
                    <Route
                      path="/onboarding"
                      element={
                        <ProtectedRoute>
                          <OnboardingPage />
                        </ProtectedRoute>
                      }
                    />
                    <Route
                      path="/recording"
                      element={
                        <ProtectedRoute>
                          <RecordingPage />
                        </ProtectedRoute>
                      }
                    />
                    <Route
                      path="/history"
                      element={
                        <ProtectedRoute>
                          <HistoryPage />
                        </ProtectedRoute>
                      }
                    />
                    <Route
                      path="/payment-history"
                      element={
                        <ProtectedRoute>
                          <PaymentHistory />
                        </ProtectedRoute>
                      }
                    />
                    <Route
                      path="*"
                      element={
                        <div>
                          <h2>404 Not Found</h2>
                          <Link to="/welcome">Go to Welcome</Link>
                        </div>
                      }
                    />
                  </Routes>
                </div>
              </QueryParamsProvider>
            </Router>
          </PayoutProvider>
        </SubmissionProvider>
      </TaskProvider>
    </AuthProvider>
  );
}

export default App;
